
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'UISidebarButton',
  props: {
    active: {
      default: false,
      type: Boolean
    },
    label: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    count: {
      type: Number as PropType<number | null>,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    },
    to: {
      type: [String, Object],
      default: ''
    },
    replace: {
      type: Boolean,
      default: false
    }
  }
})
